import { buildPathname, parsePathname } from "../../constants/routes.js";
import { pushAppUrl } from "./urlHistory.js";
import { useAccountsStore } from "../stores/accountsStore.js";
import { useNavigationStore } from "../stores/navigationStore.js";

let syncingFromUrl = false;

export function isSyncingFromUrl() {
  return syncingFromUrl;
}

function withUrlSync(fn) {
  syncingFromUrl = true;
  try {
    fn();
  } finally {
    syncingFromUrl = false;
  }
}

export function applyUrlToStores(pathname = window.location.pathname) {
  const location = parsePathname(pathname);
  const nav = useNavigationStore.getState();
  const accounts = useAccountsStore.getState();

  withUrlSync(() => {
    if (location.routeId !== nav.active) {
      nav.setActiveFromUrl(location.routeId);
    }

    if (location.routeId === "acc-ov" && location.accountId) {
      accounts.openAccountDetail(location.accountId, location.tab ?? "info", { fromUrl: true });
      return;
    }

    if (accounts.detailAccountId) {
      accounts.closeAccountDetail({ fromUrl: true });
    }
  });
}

export function syncStoresToUrl({ replace = false, routeId } = {}) {
  if (syncingFromUrl) return;

  const activeRouteId = routeId ?? useNavigationStore.getState().active;
  const { detailAccountId, detailTab } = useAccountsStore.getState();

  pushAppUrl(
    {
      routeId: activeRouteId,
      accountId: activeRouteId === "acc-ov" ? detailAccountId : null,
      tab: detailTab,
    },
    { replace },
  );
}

export function initUrlRouting() {
  applyUrlToStores(window.location.pathname);

  const initial = parsePathname(window.location.pathname);
  const canonical = buildPathname(initial);
  if (window.location.pathname !== canonical) {
    window.history.replaceState(initial, "", canonical);
  }
}

export function subscribeToPopState() {
  const onPopState = () => {
    applyUrlToStores(window.location.pathname);
  };

  window.addEventListener("popstate", onPopState);
  return () => window.removeEventListener("popstate", onPopState);
}
